// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QSbEJ{display:flex;flex-direction:column;gap:.75rem;margin:0;min-width:var(--stat-breakdown-min-width,14rem);padding:0}.QSbEJ .Vu5dC{align-items:flex-start;display:flex;text-wrap-mode:nowrap}.QSbEJ .Vu5dC .WkoAk{align-items:center;display:grid;flex-grow:1;gap:.25rem .5rem;grid-template-columns:auto 1fr;line-height:1.4;margin:0}.QSbEJ .Vu5dC .WkoAk .UZPef.icon{align-items:center;display:inline-flex!important;flex-shrink:0;font-size:.85em;margin:0!important}.QSbEJ .Vu5dC .WkoAk .gfC6C{font-size:1.1rem;font-weight:700}.QSbEJ .Vu5dC .WkoAk .p1XxI{color:var(--anchore-color-gray-500);font-size:.95rem;grid-column:2}.QSbEJ .Vu5dC .Ah1j5{font-weight:700;line-height:1.4;margin:0 0 0 1rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `QSbEJ`,
	"item": `Vu5dC`,
	"term": `WkoAk`,
	"dot": `UZPef`,
	"label": `gfC6C`,
	"description": `p1XxI`,
	"value": `Ah1j5`
};
module.exports = ___CSS_LOADER_EXPORT___;
